import { kebabCase } from 'lodash';

import { Style } from './types';

export const getCssProperties = (style: Style) => Object.keys(style).map(kebabCase).sort();
